
import { BaseVue } from "@newview/base-web";
import { Component, Watch,Prop } from "vue-property-decorator"; 
@Component({
  name: "loginout",
  components: {
  },
})
export default class loginout extends BaseVue {
  type = 1  // 跳转类型  1： 路由 2： 链接  
  async loginOut(){
    try {
      let otherconfig:any = await this.$getJson('/static/otherConfig.json')
      if(otherconfig.loginOutType){
        this.type = otherconfig.loginOutType
      }
    } catch(error) {
      this.type = 1
    }

    this.IMWaiter=null;//置空服务模式
    localStorage.clear()
    sessionStorage.clear()
    this.$Notice.close('model')
    if (window.location.href.indexOf("/index/#/") >= 0) {
      window.location.href = window.location.origin
    } else {
      this.$router.replace("/");
    }
    // if(this.type == 1) {
    //   await this.$router.replace('/') 
    // } else {
    //   window.location.href = 'http://'+window.location.host
    // }
  }
}
